import React from 'react';

export const IOS = ({ color }) => (
  <svg
    width="22"
    height="28"
    viewBox="0 0 22 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2770_3753)">
      <path
        d="M20.5842 9.69333C20.4324 9.81204 17.7582 11.3344 17.7582 14.7198C17.7582 18.6351 21.1615 20.02 21.2626 20.0541C21.2472 20.1387 20.7227 21.9512 19.4692 23.7978C18.3509 25.4235 17.1842 27.0459 15.4083 27.0459C13.6325 27.0459 13.1761 26.0039 11.1253 26.0039C9.12846 26.0039 8.41811 27.0799 6.79289 27.0799C5.16877 27.0799 4.03617 25.5763 2.73313 23.7297C1.22337 21.561 0.00390625 18.1921 0.00390625 14.9946C0.00390625 9.8648 3.30493 7.14546 6.55317 7.14546C8.27956 7.14546 9.71785 8.2897 10.8021 8.2897C11.8335 8.2897 13.4411 7.07622 15.4061 7.07622C16.1495 7.07622 18.8237 7.14546 20.5842 9.69333ZM14.4737 4.90536C15.2852 3.9315 15.8592 2.58063 15.8592 1.22975C15.8592 1.04289 15.8449 0.852735 15.8108 0.699951C14.489 0.750513 12.9166 1.58918 11.9687 2.70043C11.2254 3.55449 10.5305 4.90536 10.5305 6.27492C10.5305 6.48047 10.5634 6.68601 10.5799 6.75196C10.6635 6.76845 10.7999 6.78604 10.9351 6.78604C12.1205 6.78604 13.6116 5.98364 14.4737 4.90536Z"
        fill={color ?? '#005EE0'}
      />
    </g>
    <defs>
      <clipPath id="clip0_2770_3753">
        <rect
          width="22"
          height="26.38"
          fill="white"
          transform="translate(0 0.699951)"
        />
      </clipPath>
    </defs>
  </svg>
);
